import Event from '../../core/Event';

export default class UserEstimationsRequested extends Event {
    public static type = 'UserEstimationsRequested';

    constructor() {
        super(UserEstimationsRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/estimations/events/UserEstimationsRequested.ts